import type { FC, ReactElement } from "react"

import { buildCssClassName } from "@/3514/utils"

type TProps = { width?: number; height?: number; alt?: string; className?: string }

const Image: FC<TProps> = ({
    width = 24,
    height = 24,
    alt = "Owl logo",
    className = String()
}: TProps): ReactElement => (
    <div title={alt}>
        <svg
            width={width}
            height={height}
            className={buildCssClassName({ [className]: className })}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="12" cy="2.72461" r="2" fill="#FD4D00" />
            <g clipPath="url(#clip0_20424_13787)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.5881 14.1901L15.0686 14.0443C13.6334 13.9981 12.4324 15.1241 12.3861 16.5593C12.3803 16.7407 12.3934 16.9222 12.4254 17.1009L12.9905 20.2608C17.5127 22.2392 20.149 23.2397 20.8993 23.2626C21.2521 23.2733 21.6069 23.2789 21.9638 23.2796C22.4328 23.28 22.8131 22.9001 22.8135 22.4311C22.8136 22.3303 22.7957 22.2303 22.7599 22.1361L19.8956 14.4115C19.8476 14.282 19.7261 14.1946 19.5881 14.1901Z"
                    fill="#DA4200"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.08866 14.1901L8.60819 14.0443C10.0434 13.9981 11.2445 15.1241 11.2907 16.5593C11.2966 16.7407 11.2834 16.9222 11.2514 17.1009L10.6864 20.2608C6.16404 22.2392 3.52776 23.2397 2.77749 23.2626C2.42469 23.2733 2.06987 23.2789 1.71303 23.2796C1.24408 23.28 0.863632 22.9001 0.863281 22.4311C0.863206 22.3303 0.881081 22.2303 0.916871 22.1361L3.78115 14.4115C3.82914 14.282 3.95069 14.1946 4.08866 14.1901Z"
                    fill="#DA4200"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.30289 3.52362L9.19103 5.77571C10.9099 6.43314 12.8109 6.43314 14.5298 5.77571L20.447 3.51251C20.666 3.42874 20.9114 3.53837 20.9952 3.75738C21.0334 3.85734 21.0325 3.96805 20.9926 4.06736L20.6735 4.86137C20.2839 5.83105 20.0836 6.86643 20.0836 7.91149V9.49361V15.822V20.2982C20.0836 24.8163 16.4209 28.4789 11.9028 28.4789C7.3847 28.4789 3.72206 24.8163 3.72206 20.2982V15.822V9.49361V7.91149C3.72206 6.86763 3.50999 5.83465 3.09871 4.87523L2.76101 4.08743C2.66863 3.87192 2.76844 3.62232 2.98395 3.52994C3.08541 3.48646 3.1998 3.48419 3.30289 3.52362Z"
                    fill="#FE4D00"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.7722 17.7031H12.0301C14.6042 17.7031 16.6909 19.7899 16.6909 22.364C16.6909 24.9381 14.6042 27.0248 12.0301 27.0248H11.7722C9.19805 27.0248 7.11133 24.9381 7.11133 22.364C7.11133 19.7899 9.19805 17.7031 11.7722 17.7031Z"
                    fill="#FEA57F"
                    stroke="#FEA57F"
                    strokeWidth="0.679293"
                />
                <path
                    d="M8.34307 14.3683C9.86471 14.3683 11.0982 13.1239 11.0982 11.589C11.0982 10.0539 9.86471 8.80957 8.34307 8.80957C6.82142 8.80957 5.58789 10.0539 5.58789 11.589C5.58789 13.1239 6.82142 14.3683 8.34307 14.3683Z"
                    fill="#FFDCCE"
                />
                <path
                    d="M15.3528 14.3683C16.8745 14.3683 18.108 13.1239 18.108 11.589C18.108 10.0539 16.8745 8.80957 15.3528 8.80957C13.8312 8.80957 12.5977 10.0539 12.5977 11.589C12.5977 13.1239 13.8312 14.3683 15.3528 14.3683Z"
                    fill="#FFDCCE"
                />
                <path
                    opacity="0.9"
                    d="M15.3773 12.9999C16.1499 12.9999 16.7761 12.3681 16.7761 11.5888C16.7761 10.8095 16.1499 10.1777 15.3773 10.1777C14.6048 10.1777 13.9785 10.8095 13.9785 11.5888C13.9785 12.3681 14.6048 12.9999 15.3773 12.9999Z"
                    fill="#071C41"
                />
                <path
                    opacity="0.9"
                    d="M8.34214 12.9999C9.11468 12.9999 9.74091 12.3681 9.74091 11.5888C9.74091 10.8095 9.11468 10.1777 8.34214 10.1777C7.56961 10.1777 6.94336 10.8095 6.94336 11.5888C6.94336 12.3681 7.56961 12.9999 8.34214 12.9999Z"
                    fill="#071C41"
                />
                <path
                    d="M7.5 11C7.77615 11 8 10.7761 8 10.5C8 10.2239 7.77615 10 7.5 10C7.22386 10 7 10.2239 7 10.5C7 10.7761 7.22386 11 7.5 11Z"
                    fill="#FFDCCE"
                />
                <path
                    d="M14.5 11C14.7761 11 15 10.7761 15 10.5C15 10.2239 14.7761 10 14.5 10C14.2239 10 14 10.2239 14 10.5C14 10.7761 14.2239 11 14.5 11Z"
                    fill="#FFDCCE"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.1777 13.5949C11.1917 13.5728 11.2088 13.5459 11.2285 13.5151C11.5468 13.017 12.2681 13.0873 12.5711 13.5949C12.6905 13.7949 12.8777 13.9915 13.1327 14.1846C13.2015 14.2335 13.2149 14.3293 13.1641 14.3967C13.1596 14.4028 13.1546 14.4084 13.149 14.4136L12.9396 14.6187C12.7158 14.838 12.5212 15.0853 12.3606 15.3544L12.1142 15.7673C12.0364 15.8978 11.8675 15.9404 11.737 15.8626C11.6979 15.8392 11.6651 15.8065 11.6418 15.7673L11.3955 15.3544C11.2348 15.0853 11.0402 14.838 10.8164 14.6187L10.6123 14.4187C10.5517 14.3598 10.5511 14.263 10.6104 14.2029C10.616 14.1973 10.6219 14.1921 10.6292 14.1887C10.8443 14.0318 11.0271 13.8339 11.1777 13.5949Z"
                    fill="#FFDCCE"
                />
                <path
                    d="M9.23242 23.2275L10.377 24.288C10.4812 24.3845 10.6422 24.3845 10.7463 24.288L11.7063 23.3986C11.8105 23.3021 11.9714 23.3021 12.0756 23.3986L13.0355 24.288C13.1397 24.3845 13.3006 24.3845 13.4049 24.288L14.5495 23.2275"
                    stroke="#FE4D00"
                    strokeWidth="0.679293"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.23242 20.9189L10.377 21.9793C10.4812 22.0758 10.6422 22.0758 10.7463 21.9793L11.7063 21.09C11.8105 20.9935 11.9714 20.9935 12.0756 21.09L13.0355 21.9793C13.1397 22.0758 13.3006 22.0758 13.4049 21.9793L14.5495 20.9189"
                    stroke="#FE4D00"
                    strokeWidth="0.679293"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_20424_13787">
                    <rect width="23" height="28.5517" fill="white" transform="translate(0.5 2.72461)" />
                </clipPath>
            </defs>
        </svg>
    </div>
)

Image.displayName = "CoachingChatOwlLogoImage"

export { Image as CoachingChatOwlLogoImage }
